
    <div class="total-padding" #invisiblePadding></div>
    <div class="scrollable-content" #content>
      <ng-content></ng-content>
    </div>
  


// WEBPACK FOOTER //
// ./node_modules/ngx-virtual-scroller/ngx-virtual-scroller.d.ts.VirtualScrollerComponent.html